import { Flex } from '@volue/wave-react';
import React from 'react';

import { useAppState } from '@/overmind';

import { FeatureSearchInput } from './FeatureSearchInput';
import { FeatureSearchResult } from './FeatureSearchResult';

export function FeatureSearch() {
  const isAFeatureSelected = useAppState().selectedFeature.current != null;
  if (isAFeatureSelected) {
    return null;
  }
  return (
    <Flex
      flow="column"
      main="start"
      cross="start"
      css={{
        zIndex: 400,
        position: 'absolute',
        top: '1rem',
        left: '1rem',
        right: '1rem',
        bottom: '1rem',
        pointerEvents: 'none'
      }}
    >
      <Flex
        flow="column"
        css={{
          width: 'min(24rem, 100%)',
          maxHeight: '100%',
          pointerEvents: 'all',
          gap: '$spacingS'
        }}
      >
        <FeatureSearchInput />
        <FeatureSearchResult />
      </Flex>
    </Flex>
  );
}
